export enum StorageKey {
  IMPERSONATED_ROLE = 'trackup_impersonated_role',
  COMPANY = 'trackup_company',
}
